'use client';
import { useState } from 'react';
import Input, { InputProps } from '@repo/ui/src/components/Form/Input';
import EyeIcon from '@repo/ui/src/components/Icons/EyeIcon';
import EyeOffIcon from '@repo/ui/src/components/Icons/EyeOffIcon';
import { classNames } from '@repo/ui/src/utils/classNames';

type PasswordInputProps = Omit<InputProps, 'type' | 'endAdornment'>;

const PasswordInput = ({ inputStyles, ...rest }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Input
      {...rest}
      type={showPassword ? 'text' : 'password'}
      inputStyles={classNames('pr-12', inputStyles)}
      inputAddon={
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-500 hover:text-neutral-700 transition-colors"
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      }
    />
  );
};

export default PasswordInput;
